export enum IncidentItemTypes {
  Incident = 1,
  Log = 2,
  Job = 3,
}
